export const landingPageText = `
Welcome to the Infrastructure Australia Market Capacity Data Portal, an interactive platform designed to assist government in making better-informed infrastructure investment decisions
`;

export const requestAccessIntro =`
Access to the Infrastructure Australia Market Capacity Data Portal is reserved for eligible government stakeholders only
`;

export const requestAccessIntro2 = `
Please fill in all the fields, taking care to quote your government email address. Personal/other email addresses will not be accepted
`;

export const modellingPortalIntro = `
Welcome to the Infrastructure Australia data portal`;

export const modellingPortalSubIntro = `
`;

export const nationalPipelineIntro = `
A combined view of all current state and territory infrastructure pipelines`;

export const statePipelineIntro = `
Upload your new baseline data and view your current state or territory pipeline`;

export const caveatIntro = `
Baseline pipeline based on data collected as of Q3 2025. Next data refresh: Q2 2026`;

export const pipelineModellingIntro = `
Create and run a new or saved scenarios`;

export const nationalMapIntro = `
Explore state and national pipeline on an interactive map`;

export const scenarioDescriptionIntro = `
Scenario Description`;

export const assumptionIntro = `
You can assign project phase assumptions by project type here and they will be applied to scenario model result only. Please make sure numbers add up to 100% and be aware that the model can take longer to run post adjustment.`;

export const escalationText = `
You can adjust the escalation rate used in your pipeline. Please give a delta escalation rate* in below box and it will be applied in the scenario result. The delta escalation will only be applied to your own pipeline and not impacting data from other sources. After the adjustment the model can take longer to refresh than normal.`;

export const escalationTexttwo = `
* For example if your pipeline already considers a 3% escalation and new escalation is 5%, please enter 2% in below box`;

/** Map related text */
export const sa4Caveat = `Baseline pipeline based on data collected as of Q3 2025 excl unknown SA4 projects. Next data refresh: Q2 2026`;

export const stateCaveat = `Baseline pipeline based on data collected as of Q3 2025. Next data refresh: Q2 2026`;

/** This particular bit of text is hard coded into
 * the HTML. I was unable to use the html-react-parser
 * to parse the text.
 * https://github.com/remarkablemark/html-react-parser/issues/1725
 */
/**export const perCapitaCaveat = `Baseline pipeline based on data collected as of Q3 2025 excl unknown SA4 projects. Next data refresh: Q2 2026. 
<br><a target="_blank" href="https://cepar.edu.au/projections-australias-regional-and-remote-populations">Population calculated based on Projections for Australia's regional and remote population | CEPAR 2022.</a>`;*/

export const labourCaveat = `Labour demand includes infrastructure projects only (all pipelines excluding private buildings). Data excludes unknown SA4’s. Project level filters don’t apply on this chart.`;
